module.exports = __webpack_public_path__ + "static/img/logo.a31daf08.png";